export const COMP_VIEW_MAP = 'map';
export const COMP_VIEW_LIST = 'list';
export const COMP_VIEWS = [COMP_VIEW_LIST, COMP_VIEW_MAP];

export const liteCrmContactAttributes = [
  'buyerName',
  'landlordString',
  'ownerName',
  'ownerEmail',
  'ownerPhoneNumber',
  'sellerName',
  'tenantString',
  'tenantContactString'
];
